<template>
	<div>
		<div
			class="w-100"
			style="
				position: fixed;
				z-index: 9999;
				display: flex;
				align-items: center;
				justify-content: center;
				backdrop-filter: blur(2px);
			"
		>
			<Spinner v-if="loading" />
		</div>
		<div class="mobile-header" v-if="!showNotifications">
			<div class="d-flex align-items-center">
				<div class="position-relative d-flex side-nav-main pl-2">
					<img
						height="16px"
						@click="showsidebar = !showsidebar"
						src="../../assets/3dotsanddash.svg"
						alt=""
					/>
					<div
						class="mh-side-nav"
						@focusout="showsidebar = false"
						:class="{
							mhfixedwidth: showsidebar,
							mhtrans: !showsidebar,
						}"
					>
						<!-- v-if="progressPrimary.progress >= 20" -->
						<div class="mh-side-menu-main">
							<div
								id="hideinlaptop"
								class="d-flex align-items-center justify-content-between padding16px"
							>
								<img
									src="../../assets/NewDashboard/Mobiledesign/h3xlogo.svg"
									alt=""
								/>
								<img
									src="../../assets/NewDashboard/Mobiledesign/Cross.svg"
									alt=""
								/>
							</div>
							<div class="hedaer-down-border" id="hideinlaptop"></div>
							<ul class="list-unstyled">
								<li
									v-for="menu in menuItems"
									:key="menu.label"
									:style="menu.childRoutes.length ? { width: '93%' } : {}"
									v-show="showSidebarMenu(menu)"
									:class="
										checkActive(menu)
											? 'mh-activenavclass-dropdown'
											: 'mh-inactivenavclass-dropdown'
									"
									@click="
										menu.childRoutes.length > 0
											? (menu.showChildRoutes = !menu.showChildRoutes)
											: menu.onClick($router, $route)
									"
								>
									<div
										class="w-100 d-flex align-items-center justify-content-between"
									>
										<div>
											<img :src="bindSidebarIcon(menu)" />
											<span class="pl-2">{{ menu.label }}</span>
										</div>
										<template v-if="menu.childRoutes.length > 0">
											<img
												v-if="menu.showChildRoutes"
												src="../../assets/sidebar/sidebarUpArrow.svg"
												alt=""
											/>
											<img
												v-else
												src="../../assets/sidebar/sidebardownarrow.svg"
												alt=""
											/>
										</template>
									</div>
									<b-collapse
										v-if="menu.childRoutes.length > 0"
										v-model="menu.showChildRoutes"
									>
										<div class="ml-3 mt-3 pl-3">
											<div
												v-for="submenu in menu.childRoutes"
												:key="submenu.label"
												:class="
													checkActive(submenu)
														? 'mh-selected-suboption'
														: 'mh-unselected-suboption'
												"
												@click.stop="handleSubmenuClick(submenu)"
											>
												<div
													v-if="checkActive(submenu)"
													class="sel-line-sidebar"
												></div>
												{{ submenu.label }}
											</div>
										</div>
									</b-collapse>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="ml-3 d-flex">
					<img
						height="16px"
						src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xbeta_logo.svg"
						alt=""
					/>
				</div>
			</div>

			<div class="d-flex align-items-center mr-2" v-if="hasAccess()">
				<img
					class="mr-1 pointer"
					@click="openSearch"
					src="../../assets/img/header-search.svg"
					alt=""
				/>
				<div
					class="notificationdd position-relative mr-3"
					@click="gotoNotification"
				>
					<div
						class="pointer d-flex flex-column justify-content-center align-items-center position-relative"
					>
						<div
							:style="{
								right:
									unreadCount < 10
										? '-6px'
										: unreadCount >= 10 && unreadCount <= 99
										? '-10px'
										: '-18px',
							}"
							class="notification-count-tag fw-M fs-600 fs-10 text-white fam-mont"
						>
							{{ unreadCount > 99 ? "99+" : unreadCount }}
						</div>
					</div>
					<img src="../../assets/img/header/greybell.svg" alt="" />
				</div>

				<div
					class="position-relative"
					@click="showsignout = !showsignout"
					v-closable="{
						exclude: ['profile-image'],
						handler: 'closeDpcard',
					}"
				>
					<img class="mb-profile-pic-1" :src="userInfo.image" alt="" />
					<div v-if="showsignout" class="mb-header-box">
						<div class="mb-header-name d-flex align-items-center">
							<img class="mr-1 mb-profile-pic-2" :src="userInfo.image" alt="" />

							<div class="text-break">{{ userInfo.username }}</div>
						</div>
						<div
							class="mb-resume-name-2 d-flex align-items-center mt-3 mb-3"
							@click="myProfile()"
						>
							<img
								class="mr-1"
								src="../../assets/mobile/dashboard/mb-settings.svg"
								alt=""
							/>
							Account Settings
						</div>
						<div
							v-if="userInfo.isPanelistVerified"
							@click="goToPayment()"
							class="mb-resume-name-2 d-flex align-items-center mt-3 mb-3"
						>
							<img
								class="mr-1"
								src="../../assets/New Profile/bills.svg"
								alt=""
							/>
							Hire3x Wallet
						</div>
						<div
							@click="goToHelp()"
							class="d-flex align-items-center pointer hoverclass"
						>
							<div class="mr-2">
								<img src="../../assets/New Profile/Help.svg" alt="" />
							</div>
							<div class="profile-container-subhead">Help</div>
						</div>
						<div class="demograpgic-data"></div>
						<div
							class="d-flex align-items-center justify-content-center mt-2 mb-blue-txt-3"
							@click="logout()"
						>
							<img
								class="mr-1"
								src="../../assets/mobile/dashboard/mb-signout.svg"
								alt=""
							/>
							Log Out
						</div>
					</div>
				</div>
			</div>
			<div v-else class="d-flex align-items-center">
				<b-button
					class="d-flex justify-content-end mb-cancelBtn mr-3 pointer"
					@click="login()"
				>
					Login
				</b-button>
				<b-button @click="signup()" class="candash-fixwidBtn mr-3 pointer">
					Sign Up
				</b-button>
			</div>
		</div>
		<div v-if="searchActive" class="search-suggestion-container">
			<img
				id="hideinmobile"
				@click="closeSearchDropdown"
				class="hp-whitecross-pos pointer"
				src="../../assets/newdesign/home/whitecross.svg"
				alt=""
			/>
			<div :class="{ 'extra-div': searchActive }"></div>
			<!-- Expanded Search Container -->
			<div class="header-center-area" ref="searchContainer">
				<!-- Tabs -->
				<div class="search-tabs-container">
					<div
						class="search-tab"
						@click="selectTab('job')"
						:class="selectedTab == 'job' ? 'active' : ''"
					>
						Jobs
					</div>
					<span class="divider">|</span>
					<div
						class="search-tab"
						@click="selectTab('assessment')"
						:class="selectedTab == 'assessment' ? 'active' : ''"
					>
						Assessments
					</div>
					<span class="divider">|</span>
					<div
						class="search-tab"
						@click="selectTab('course')"
						:class="selectedTab == 'course' ? 'active' : ''"
					>
						Courses
					</div>
				</div>

				<!-- Search Bar -->
				<div class="search-bar-wrapper is-active">
					<div class="d-flex gap-2 w-100">
						<img
							id="hideinlaptop"
							class="shadow pointer"
							src="../../assets/guestHeader/search-back.svg"
							alt="Close Search"
							@click="closeSearchDropdown"
						/>
						<div class="header-search">
							<b-form-input
								ref="headerSearchInput"
								type="text"
								name="global-search"
								placeholder="Search.."
								v-model="searchQuery"
								@input="onSearchInput"
								@keydown.enter.native.prevent="
									performSearch(getLiveSearchQuery())
								"
								autocomplete="off"
								autocapitalize="off"
								autocorrect="off"
								spellcheck="false"
							></b-form-input>
							<img
								src="../../assets/guestHeader/searchBar.svg"
								alt="Search Icon"
								class="pointer"
								@click="performSearch(getLiveSearchQuery())"
							/>
						</div>
					</div>

					<!-- Search Dropdown Content Component -->
					<SearchDropdown
						:isVisible="searchActive"
						:selectedTab="selectedTab"
						:headerSearchQuery="searchQuery"
						:headerSearchSuggestion="searchSuggestion"
						:isSearching="isSearchLoading"
						@close-modal="closeSearchDropdown"
						@click-history="handleHistorySelection"
						@openResumeClinic="openResumeClinicModal"
					/>
				</div>
			</div>
		</div>
		<!-- <div v-else style="height: 100dvh">
			<Notifications
				class="notifications-overlay"
				@closeNotificationDropdown="showNotifications = false"
				@changeCountvalue="changeReadUnreadcount"
			/>
		</div> -->
		<ResumeClinicModal
			v-if="showResumeClinicModal"
			:showModal="showResumeClinicModal"
			@modalClose="closeResumeClinicModal"
			:showfromhelpsection="false"
			:clinicDatafromhs="resumeClinicData"
			@openLoginModal="openLoginModal"
			@openLoginModalWithJobID="openLoginModalWithJobID"
		/>
		<LogoutConfirmModal
			:visible="showLogoutModal"
			@confirm="confirmLogout"
			@cancel="cancelLogout"
		/>
	</div>
</template>

<script>
import { hasAccess } from "@/utils/tokenCheck";
import ResumeClinicModal from "@/components/BuilderPage/ResumeclinicModal.vue";
import LogoutConfirmModal from "@/components/BuilderPage/Cards/LogoutConfirmModal.vue";
import { mapGetters, mapMutations } from "vuex";
import { getToken, getLoginType } from "../../utils/tokenCheck";
import {
	getCandInfo,
	signOutDevices,
	getNotificationData,
	getCandidatePrimaryProfile,
	getProfileCompletion,
	userInfo,
	getSearchSuggestions,
	resumeAnalysis,
} from "../../utils/apiFunctions";
import { checkAccess } from "../../router/index";
import errorModal from "../../components/mixin/toast";
import EventBus from "@/utils/EventBus";
import menuItems from "@/utils/sideBarMenu.js";
import Notifications from "../../components/Notifications.vue";
import { Capacitor } from "@capacitor/core";
import SearchDropdown from "./SearchDropdown.vue";
import { config } from "@/config";
import Spinner from "./Spinner.vue";
import globalSearchMixin from "@/components/mixin/globalSearchMixin";
export default {
	data() {
		return {
			showLogoutModal: false,
			collapseTimeout: null,
			menuItems: menuItems,
			showsignout: false,
			mini: true,
			dropValue: false,
			title: {},
			showsidebar: false,
			showingProfileMod: false,
			token: null,
			showNotifications: false,
			searchActive: false,
			selectedTab: "job",
			searchQuery: "",
			searchSuggestion: [],
			config,
			loading: false,
			showResumeClinicModal: false,
			resumeClinicData: {},
		};
	},
	mixins: [errorModal, globalSearchMixin],
	components: {
		Notifications,
		SearchDropdown,
		Spinner,
		LogoutConfirmModal,
		ResumeClinicModal,
	},
	watch: {
		showsidebar(newVal) {
			if (newVal) {
				this.cancelCollapse();
				if (
					this.$route.name === "JobSearch" ||
					this.$route.name === "JobProgress"
				) {
					this.openjoboptions = true;
				} else {
					this.openjoboptions = false;
				}
			} else {
				this.scheduleCollapse();
			}
		},
		title(value) {
			this.$store.commit("userVUEX/setPageTitle", value);
		},
		"$route.query.bookmarked"() {
			this.openjoboptions = true;
		},
		"$route.query.show"() {
			this.openjoboptions = true;
		},
		"$route.query.display"() {
			this.openjoboptions = true;
		},
		$route(value) {
			if (value.name == "CandJdProgress" && !this.$route.query.redirect) {
				this.title = {
					titleName: "JD Progress",
					path: "/jobdetails",
				};
			} else if (value.name == "CandidateAssessmentProgress") {
				this.title = {
					titleName: "Assessment",
					path: "/assessments",
				};
			} else if (
				value.name == "CandidateDocsList" ||
				value.name == "documentsUpload"
			) {
				this.title = {
					titleName: "Documents",
					path: "/documents",
				};
			} else if (
				value.name == "jobsearch" ||
				value.name == "particularjobdetails" ||
				this.$route.query.redirect == "particularjobdetails"
			) {
				this.title = {
					titleName: "Job Search",
					path: "/jobsearch",
				};
			} else if (this.checkVideoResume) {
				this.title = {
					titleName: "Video Resume",
					path: "/videoresume",
				};
			} else if (this.checkdocsDashboard) {
				this.title = {
					titleName: "Dashboard",
					path: "/dashboard",
				};
			} else if (value.name == "Profile") {
				this.title = {
					titleName: "Profile",
					path: "/profile",
				};
			}
		},
	},
	created() {
		this.fetchUnreadCount();
		EventBus.$on("login-success", this.onLoginSuccess);
		EventBus.$on("onboarding-fetch-post-login", this.onLoginSuccess);
		EventBus.$on("spinner-start", this.onLoginSuccess);
	},
	mounted() {
		// document.addEventListener("click", this.handleDocumentClick, true);

		// Attach a click event listener to the document body
		document.body.addEventListener("click", this.handleClickOutside);
	},
	beforeDestroy() {
		// document.removeEventListener("click", this.handleDocumentClick, true);

		// Remove the click event listener when the component is destroyed
		document.body.removeEventListener("click", this.handleClickOutside);
		EventBus.$off("login-success", this.onLoginSuccess);
		EventBus.$off("onboarding-fetch-post-login", this.onLoginSuccess);
	},
	computed: {
		unreadCount() {
			if (this.showUnreadCount) return this.showUnreadCount;
			else return 0;
		},
		...mapGetters(["roles"]),
		...mapGetters("userVUEX", {
			selTheme: "getSelectedTheme",
			// token: "getToken",
			userInfo: "getUserInfo",
			showUnreadCount: "getUnreadCount",
		}),

		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
			progressPrimary: "getCandProgressRespPrimary",
			getcandidateInfo: "getcandidateInfo",
			primaryCandidateInfo: "getPrimaryCandidateInfo",
		}),
		checkHome() {
			const paths = ["Homepage"];
			return paths.includes(this.$route.name);
		},
		// check route to candidate side dashboard

		checkdocsDashboard() {
			const paths = [
				"CandidateDashboard",
				"UploadCandidateDocs",
				"uploadDocuments",
			];
			return paths.includes(this.$route.name);
		},

		checkVideoResume() {
			const paths = [
				"videoresume",
				"systempermission",
				"addsnapshots",
				"createresumevideo",
			];
			return paths.includes(this.$route.name);
		},
	},
	methods: {
		hasAccess,
		handleDocumentClick(event) {
			if (!this.searchActive) return;

			const searchContainer = this.$refs.searchContainer;
			if (searchContainer && !searchContainer.contains(event.target)) {
				this.closeSearchDropdown();
			}
		},
		async openResumeClinicModal() {
			await this.fetchResumeClinicData();
			this.showResumeClinicModal = true;
		},
		async fetchResumeClinicData() {
			try {
				const res = await resumeAnalysis();
				if (res.status === 200) {
					this.resumeClinicData = res.data?.data?.analysis || {};
				}
			} catch (error) {
				console.log(error);
			}
		},
		closeResumeClinicModal() {
			this.showResumeClinicModal = false;
		},
		openLoginModal(uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", null);
			EventBus.$emit("open-login-modal");
		},
		openLoginModalWithJobID(jobId, uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", jobId);
			EventBus.$emit("open-login-modal");
		},
		selectTab(data) {
			console.log("method called");

			this.selectedTab = data;
			this.searchQuery = "";
			this.searchSuggestion = [];
		},
		openSearch() {
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
			this.searchActive = true;
		},
		closeSearchDropdown() {
			this.searchActive = false;
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
		},
		getLiveSearchQuery() {
			const inputRef = this.$refs.headerSearchInput;
			if (!inputRef) return (this.searchQuery || "").toString();

			const rootEl = inputRef.$el || inputRef;
			if (rootEl && typeof rootEl.value === "string") {
				return rootEl.value;
			}

			const nestedInput =
				rootEl && rootEl.querySelector ? rootEl.querySelector("input") : null;
			return nestedInput && typeof nestedInput.value === "string"
				? nestedInput.value
				: (this.searchQuery || "").toString();
		},
		handleHistorySelection(query) {
			this.searchQuery = query;
			this.performSearch(query);
		},
		performSearch(forcedQuery = null) {
			const query = (
				forcedQuery ??
				this.getLiveSearchQuery() ??
				this.searchQuery
			)
				.toString()
				.trim();
			const type = this.selectedTab;
			if (!query) return;

			this.searchQuery = query;
			this.closeSearchDropdown();
			this.handleEnterSearch(query, type);
		},
		gotoNotification() {
			this.$router.push({ path: "/notifications" });
		},
		changeReadUnreadcount(change) {
			this.unreadCount += change;
		},
		async fetchUnreadCount() {
			this.$store.dispatch("userVUEX/fetchUnreadCount");
		},
		goToPayment() {
			if (Capacitor.isNativePlatform())
				window.location.replace("https://utility.hire3x.com/wallet");
			else window.open("https://utility.hire3x.com/wallet");
		},
		handleSubmenuClick(submenu) {
			Promise.resolve(submenu.onClick(this.$router)).catch(() => {});
			this.showsidebar = false;
		},
		scheduleCollapse() {
			this.collapseTimeout = setTimeout(() => {
				this.menuItems.forEach((item) => (item.showChildRoutes = false));
			}, 300); // 300ms delay to allow cursor to move into submenu
		},
		cancelCollapse() {
			if (this.collapseTimeout) {
				clearTimeout(this.collapseTimeout);
				this.collapseTimeout = null;
			}
			this.menuItems.forEach((menu) => {
				menu.showChildRoutes = this.checkActive(menu);
			});
		},
		bindSidebarIcon(menu) {
			let iconFile = ""; // Declare in outer scope
			try {
				iconFile = menu.isHovered
					? menu.hoverIcon
					: this.checkActive(menu)
					? menu.activeIcon
					: menu.icon;

				return require(`@/assets/sidebar/MobSidebar/${iconFile}`);
			} catch (e) {
				console.warn("Icon not found:", menu.label, iconFile);
				return "";
			}
		},
		checkActive(menu) {
			if (menu.label == "Job Search") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) !== true
				);
			} else if (menu.label == "Saved Jobs") {
				return (
					this.$route.name === "JobSearch" &&
					this.getBoolean(this.$route.query.bookmarked) === true
				);
			} else if (menu.childRoutes?.length) {
				return menu.childRoutes.some(
					(child) =>
						child.routeName && child.routeName.includes(this.$route.name)
				);
			} else if (menu.routeName && menu.routeName.includes(this.$route.name)) {
				return true;
			}

			return false;
		},
		showSidebarMenu(menu) {
			if (menu.label == "My Interview") {
				return this.userInfo.isPanelistVerified;
			}
			return true;
		},
		getBoolean(value) {
			return value === "true" || value === true;
		},
		closeCreateProfile() {
			if (
				this.$route.name == "CandidateDashboard" &&
				this.showingProfileMod == true
			) {
				this.showingProfileMod = false;
				EventBus.$emit("create-new-profile", false);
			}
		},
		goToProfile() {
			this.$router.push({
				name: "MyProfile",
			});
		},
		handleClickOutside(event) {
			// Check if the click event occurred outside of the sidebar
			const sidebar = document.querySelector(".side-nav-main");
			if (sidebar && !sidebar.contains(event.target)) {
				// If the click is outside the sidebar, close it
				this.showsidebar = false;
			}
		},
		showModal() {
			if (this.showingProfileMod === false) {
				this.showingProfileMod = true;
				EventBus.$emit("create-new-profile", true);
			} else {
				this.closeCreateProfile();
			}
		},
		closeDpcard() {
			this.showsignout = false;
		},
		signup() {
			location.replace(`${this.config.websiteBase}register`);
		},
		goToHelp() {
			window.open(`${this.config.websiteBase}contactus`);
		},
		login() {
			if (this.$route.name != "AccountDisabled") {
				location.replace(
					`https://app.hire3x.com/login?redirect=${this.$route.fullPath}`
				);
			} else {
				location.replace("https://app.hire3x.com/login");
			}
		},
		async onLoginSuccess() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 3000);
			this.$forceUpdate();
		},

		...mapMutations({
			setTheme: "userVUEX/setSelectedTheme",
		}),
		myProfile() {
			this.$router.push({
				name: "MainProfile",
			});
		},
		logout(){
			this.showLogoutModal = true;
		},
		async confirmLogout() {
			this.showDeviceActivityShimmer = true;
			this.$store.commit("candidateVUEX/setResclinicRename", false);
			try {
				if (!getLoginType() || !getLoginType().logged_in || getLoginType().logged_in != "google") {
					let payload = {
						id: localStorage.getItem("currentLogin"),
					};
					await signOutDevices(payload); // Call the API to sign out of the specific device
					this.$socket.emit("signOut", {
						email: localStorage.getItem("currentEmail"),
						userid: payload,
					});
				}
				// this.$store.commit("candidateVUEX/setCandidateInfo", {});
				localStorage.clear();
				this.$store.dispatch("userVUEX/LogOut");
				this.allProfileList = [];
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				this.cancelLogout();
				console.error("Error:", error); // Log the error to the console
			}
		},
		cancelLogout() {
			this.showLogoutModal = false;
		},
		getSvgPath() {
			return svgPath46(this);
		},
	},
};
</script>

<style lang="scss">
@media (max-width: 1028px) {
	.hedaer-down-border {
		margin: 0 15px 0 16px;
		width: 92%;
		border-top: 3px solid transparent;
		border-image: repeating-linear-gradient(
				to right,
				#efefef 0,
				#efefef 12px,
				transparent 12px,
				transparent 18px
			)
			1;
	}
	.padding16px {
		padding: 16px;
	}
	.mob-resume-box-blue-line {
		position: absolute;
		background-color: #20639b;
		/* width: 100px; */
		width: 35px;
		height: 4px;
		top: 37px;
		border-radius: 2px;
		left: -3px;
	}
	.mh-side-nav {
		position: fixed;
		top: calc(0px + env(safe-area-inset-top));
		left: 0;
		// background: #fcfcfc;
		width: 0px;
		// border-radius: 0px;
		/* height: calc(100dvh - 7%); */
		height: 100vh;
		box-shadow: 9px 4px 13px 0px #0000001a;

		z-index: 15;
		overflow: hidden;
		background: linear-gradient(134.23deg, #ffffff 5.69%, #ebf0fc 96.31%);
		border: 1.5px solid #e9e9e9;
		border-radius: 0px 36px 36px 0px;
	}

	.mh-side-nav:hover {
		width: 215px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.mh-side-nav:hover .mh-side-menu-main ul li h6 {
		visibility: visible;
		transition-delay: 0.5s;
	}

	.mh-activenavclass {
		color: #324054 !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 500;
	}
	.mh-inactivenavclass {
		color: #324054 !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 500;
	}

	.mh-activenavclass-back {
		background-color: #eef3f7;
		border-radius: 4px;
		padding: 7px 8px;
		color: #20639b !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 600;
	}
	.mh-inactivenavclass-back {
		background-color: transparent;
		border-radius: 15px;
		padding: 7px 8px;
		color: #324054 !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 500;
	}

	.mh-activenavclass-dropdown {
		background-color: transparent;
		border-radius: 4px;
		padding: 7px 8px;
		color: #20639b !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 600;
	}
	.mh-inactivenavclass-dropdown {
		background-color: transparent;
		border-radius: 15px;
		padding: 7px 8px;
		color: #324054 !important;
		font-family: "Montserrat", sans-serif;
		font-size: 14px;
		font-weight: 500;
	}

	.mhfixedwidth {
		width: 302px !important;
	}
	.mhtrans {
		width: 0px !important;
	}

	.mh-side-menu-main li img {
		padding-right: 10px;
		cursor: pointer;
	}

	.mh-side-menu-main {
		// padding-top: calc(20px + env(safe-area-inset-top));
		padding-left: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		height: calc(100dvh - 20px);
	}

	.mh-side-menu-main ul li {
		margin: 12px 12px;
		white-space: nowrap;
		position: relative;
	}

	.mh-side-menu-main ul li .active {
		color: #ad1927;
		font-weight: 600;
	}

	.mh-side-menu-main ul li .active::before {
		content: "";
		height: 25px;
		width: 5px;
		background: #ad1927;
		border-radius: 0 3px 3px 0;
		position: absolute;
		left: -24px;
	}

	.mh-side-menu-main ul li h6 {
		background: #72738e;
		border-radius: 3px 0px 0px 3px;
		position: absolute;
		right: 0;
		visibility: hidden;
		margin: 0;
		font-weight: 500;
		font-size: 13px;
		line-height: 19px;
		color: #fcfcfc;
		width: 46px;
		text-align: center;
		cursor: pointer;
	}

	.changetheme {
		color: var(--Primary-Gray, #324054);
		font-size: 14px;
		font-weight: 500;
	}

	/* .changetheme-cont {
  position: absolute;
  bottom: 19px;
  left: 28px;
} */

	.greenBack {
		border-radius: 8px;
		background: #e1fff0;
		padding: 10px;
	}

	.color-option.selected {
		border: 2px solid #4c78ce;
	}

	.greenRound {
		height: 15px;
		width: 15px;
		border-radius: 50%;
		background-color: #57b284;
	}

	.redRound {
		height: 15px;
		width: 15px;
		border-radius: 50%;
		background-color: #af1b2d;
	}

	.blueRound {
		height: 15px;
		width: 15px;
		border-radius: 50%;
		background-color: #20639b;
	}

	.purpleRound {
		height: 15px;
		width: 15px;
		border-radius: 50%;
		background-color: #3f2668;
	}
	.no-resume-text {
		color: #333333;
		font-size: 16px;
		font-weight: 600;
	}

	.color-txt {
		color: var(--Primary-Gray, #324054);
		font-size: 12px;
		font-weight: 500;
	}

	.mh-jobs-sidebar-cont {
		border-left: 2px solid #8c8c8c8c;
	}

	.mh-selected-suboption {
		background: #20639b14;
		font-family: "Montserrat", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: #20639b;
		border-radius: 4px;
		padding: 7px 10px;
		margin: 2px 0;
		position: relative;
	}

	.mh-unselected-suboption {
		background: transparent;
		font-family: "Montserrat", sans-serif;
		font-size: 12px;
		font-weight: 500;
		color: #344054;
		border-radius: 4px;
		padding: 7px 10px;
		margin: 2px 0;
	}

	.search-suggestion-container .header-search {
		padding: 2px !important;
	}
	.search-suggestion-container {
		position: fixed;
		top: calc(0px + env(safe-area-inset-top));
		left: 0;
		width: 100vw;
		max-width: 100vw;
		height: 100vh;
		z-index: 2069;
		background: #f7f7f7;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.search-suggestion-container .header-center-area {
		position: relative;
		width: 100%;
		padding: 15px 5px;
		pointer-events: auto;
		height: fit-content;
	}
	.search-suggestion-container .search-tabs-container {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #c4dcf6;
		border-radius: 74px;
		padding: 5px 6px;
		gap: 15px;
		background-color: white;
		margin-bottom: 10px;
		opacity: unset;
		width: 95%;
		left: 10px;
		transform: unset;
		height: unset;
	}
	.search-suggestion-container .search-tab {
		font-size: 16px;
		color: #20639b;
		cursor: pointer;
		font-weight: 400;
		padding: 4px;
		border-radius: 30px;
		transition: all 0.2s;
		line-height: 2;
	}
	.search-suggestion-container .search-tab.active {
		background: #20639b;
		color: white;
	}
	.search-suggestion-container .header-search {
		border: 1.5px solid #efefef;
		border-radius: 74px;
		position: relative;
		width: 100%;
		padding: 10px;
		background: white;
		flex: 1;
		box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.02), 0px 2px 2px rgba(0, 0, 0, 0.03),
			0px 0px 1px rgba(0, 0, 0, 0.03);
	}
	.search-suggestion-container .header-search img {
		position: absolute;
		left: 19px;
		top: 14px;
	}
	.search-suggestion-container .header-search .form-control {
		border: none;
		padding: 0.375rem 0.75rem 0.375rem 42px;
		border-radius: 50px;
	}
	.search-suggestion-container .header-search .form-control:focus {
		box-shadow: none;
	}
	.search-suggestion-container .search-bar-wrapper {
		position: fixed;
		padding: 15px;
		background-color: #ffffff;
		pointer-events: auto;
		/* box-shadow: 8px 2px 19px 0px #0000001a, 33px 10px 35px 0px #00000017,
    75px 22px 47px 0px #0000000d, 133px 38px 56px 0px #00000003,
    208px 60px 61px 0px #00000000; */
		box-shadow: 133px 38px 56px rgba(0, 0, 0, 0.01),
			75px 22px 47px rgba(0, 0, 0, 0.05), 33px 10px 35px rgba(0, 0, 0, 0.09),
			8px 2px 19px rgba(0, 0, 0, 0.1);
		border-radius: 20px 20px 0 0;
	}
	.search-suggestion-container .search-bar-wrapper.is-active {
		top: calc(78px + env(safe-area-inset-top));
		max-width: 95%;
		width: 95%;
		left: 11px;
	}
	.search-suggestion-container .search-dropdown-content {
		/* height: calc(100dvh - 200px) !important;
  min-height: unset !important;
  overflow-y: auto; */
		width: 100%;
		left: 50%;
		padding: 0px;
		padding-right: 2px;
		margin-top: -1px;
		/* padding-top: 10px; */
		box-shadow: none;
		min-height: unset;
		max-height: unset;
		max-height: calc(100dvh - 168px);
		max-height: calc(100dvh - 168px);
		overflow: hidden auto;
		border-radius: 0 0 20px 20px;
		box-shadow: 133px 38px 56px -30px rgba(0, 0, 0, 0.01),
			75px 22px 47px -25px rgba(0, 0, 0, 0.05),
			33px 10px 35px -20px rgba(0, 0, 0, 0.09),
			8px 2px 19px -10px rgba(0, 0, 0, 0.1);
	}
	.mobile-header {
		.search-tabs-container {
			// margin-top: 15px;
			top: 5px;
		}
		.search-dropdown-content {
			height: calc(100vh - 180px) !important;
		}
		.search-suggestion-container .header-center-area {
			position: relative;
			width: 100%;
			padding: 15px;
			pointer-events: auto;
			height: -moz-fit-content;
			height: fit-content;
		}
	}
}
</style>
